<style scoped>
.btn_shadow {
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 4px 4px 10px #838383, -4px -4px 10px #ffffff !important;
}

.btn_shadow_half {
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 2px 2px 5px #838383, -2px -2px 5px #ffffff !important;
}

.headline {
  background-color: #1b2643;
  width: 100%;
  height: 60px;
}

.content {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.card_headline {
  background-color: #1b2643;
  border-radius: 3px;
  width: 600px;
  height: 60px;
  color: white;
  font-size: 14px;
}

.active_text {
  border-bottom: 2px solid #ffffff;
  height: 60px;
}

.headline p {
  color: #ffffff;
  font-size: 14px;
  margin: 0;
}

td {
  border-bottom: 1px solid #dbdbdb;
}

#container {
  width: 90%;
  padding-top: 40px;
}

.confirm-btn {
  margin-bottom: 12px;
}

.v-progress-circular {
  margin: 1rem;
}

#form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>

<template>
  <div>
    <div class="pa-3 headline">
      <p>{{ $t('campaignSetting.editCampaign') }}</p>
    </div>

    <div class="content pa-10">
      <v-form ref="form">
      <div id="form-wrapper">
        <v-btn
          color="#1b2643"
          class="white--text btn_shadow_half"
          style="width: fit-content"
          @click="turnBack($t('campaignSetting.backMessage'))"
        >
          {{ $t('common.back') }}
        </v-btn>

        <div>
          <p
            class="text-body-2"
            v-html="$t('campaignSetting.campaignSettingDescription')"
          ></p>

          <v-text-field
            v-model="campaignCodeField"
            :label="$t('campaignSetting.campaignCodeNonEditable')"
            disabled
            persistent-placeholder
            outlined
            required
            :rules="[rules.required, rules.halfSize]"
          ></v-text-field>

          <v-text-field
            v-model="campaignNameField"
            :label="$t('campaignSetting.campaignName')"
            persistent-placeholder
            outlined
            required
            :rules="[rules.required]"
          ></v-text-field>
        </div>

        <div>
          <p
            class="text-body-2"
            v-html="$t('campaignSetting.uploadCsvCouponCodeAndPasswordPrompt')"
          ></p>

          <v-row>
            <v-col cols="7">
              <v-file-input
                v-model="fileInput"
                accept="text/csv"
                :label="$t('campaignSetting.addCouponListCsv')"
                @change="getFileContent"
                persistent-placeholder
                outlined
                :error-messages="fileErrorMessage"
              ></v-file-input>
            </v-col>

            <v-col cols="5" class="mt-2">
              <v-btn @click="getFileSample()" class="btn_shadow_half">
                <v-icon small> mdi-download </v-icon>
                {{ $t('campaignSetting.sampleCsv') }}
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <div>
          <p class="text-body-2">
            {{ $t('campaignSetting.intellaVersionAndScenarioSettingPrompt') }}
          </p>
          <v-checkbox
            v-model="isDynamic"
            :label="$t('campaignSetting.dynamicCampaign')"
          ></v-checkbox>
          <v-select
            :label="$t('campaignSetting.scenario')"
            v-model="formInput.scenarioSelectItem"
            :items="scenarioSelectItems"
            item-text="label"
            return-object
            item-value="id"
            outlined
            persistent-placeholder
            :rules="[rules.required, rules.validSelection]"
            :disabled="isDynamic"
          >
          </v-select>
        </div>

        <div>
          <p class="text-body-2">
            {{ $t('campaignSetting.setExamsPerCouponPrompt') }}
          </p>

          <v-row>
            <v-col cols="4">
              <v-select
                :label="$t('campaignSetting.interviewCount')"
                v-model="typeLimited"
                :items="limitList"
                outlined
                persistent-placeholder
                :rules="[rules.required, rules.inLimitList]"
              >
              </v-select>
            </v-col>

            <v-col cols="2">
              <v-text-field
                v-show="
                  typeLimited ==
                  $t('campaignSetting.interviewCountOption.specifyNumber')
                "
                v-model="limitsField"
                :label="$t('campaignSetting.count')"
                persistent-placeholder
                outlined
                required
                :rules="[rules.required, rules.number]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </div>

        <hr />

        <p class="text-body-2">
          {{ $t('campaignSetting.setCampaignOpenAndExamPeriodPrompt') }}
        </p>

        <div>
          <p>
            {{ $t('campaignSetting.publicPeriod') }}
          </p>

          <v-row>
            <v-col cols="6">
              <set-schedule
                :cardTitle="String($t('campaignSetting.startDate'))"
                :unixDateTime="openTimeField"
                @changeDateTime="openTimeField = $event"
              />
            </v-col>

            <v-col cols="6">
              <set-schedule
                :cardTitle="String($t('campaignSetting.endDate'))"
                :unixDateTime="closedTimeField"
                @changeDateTime="closedTimeField = $event"
              />
            </v-col>
          </v-row>
        </div>

        <div>
          <p>{{ $t('campaignSetting.examPeriod') }}</p>

          <v-checkbox
            v-model="isMatch"
            :label="$t('campaignSetting.sameAsPublicPeriod')"
          ></v-checkbox>

          <v-row v-show="!isMatch">
            <v-col cols="6">
              <set-schedule
                :cardTitle="String($t('campaignSetting.startDate'))"
                @changeDateTime="startTimeField = $event"
                :unixDateTime="startTimeField"
              />
            </v-col>

            <v-col cols="6">
              <set-schedule
                :cardTitle="String($t('campaignSetting.endDate'))"
                @changeDateTime="endTimeField = $event"
                :unixDateTime="endTimeField"
              />
            </v-col>
          </v-row>
        </div>

        <hr />

        <div class="d-flex justify-center" style="gap: 20px">
          <v-btn
            color="#1b2643"
            class="white--text confirm-btn btn_shadow"
            @click="dialogConfirm = !dialogConfirm"
            :disabled="inputted || isSettingDisabled"
          >
            {{ $t('campaignSetting.edit') }}
          </v-btn>

          <v-btn
            color="error"
            class="white--text confirm-btn btn_shadow"
            @click="dialogDelete = !dialogDelete"
          >
            {{ $t('campaignSetting.delete') }}
          </v-btn>
        </div>
      </div>
      </v-form>
    </div>

    <v-dialog v-model="dialogConfirm" width="600px">
      <v-card>
        <v-card-title
          class="justify-center card_headline"
          style="font-size: 17px"
        >
          登録前確認
        </v-card-title>

        <v-card width="80%" class="mx-auto card_shadow_half mt-8">
          <v-card-title>{{ campaignCodeField }}</v-card-title>

          <v-card-subtitle>
            {{ campaignNameField }}
          </v-card-subtitle>

          <v-card-text>
            <template v-if="fileName">
              <v-icon>mdi-paperclip</v-icon>
              {{ fileName }}
            </template>
            <br />

            {{ $t('campaignSetting.scenario') }}：{{
              formInput.scenarioSelectItem?.label
            }}<br />
            {{ $t('campaignSetting.publicPeriod') }}：{{
              UnixTimeToString(openTimeField)
            }}
            〜
            {{ UnixTimeToString(closedTimeField) }}

            <br />

            {{ $t('campaignSetting.examPeriod') }}：{{
              UnixTimeToString(startTimeField)
            }}
            〜
            {{ UnixTimeToString(endTimeField) }}
          </v-card-text>
        </v-card>

        <v-card width="80%" class="mx-auto mt-5 card_shadow_half" elevation="0">
          <v-simple-table class="pr-5 pl-5 pt-2 pb-4">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    {{ $t('common.couponCode') }}<br />(ticket_id)
                  </th>
                  <th class="text-left">
                    {{ $t('common.password') }}<br />(password)
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="coupon in coupons" :key="coupon.id">
                  <td>{{ coupon.couponCode }}</td>
                  <td>{{ coupon.password }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>

        <v-card width="80%" class="mx-auto mt-5" elevation="0">
          <v-card-text class="pa-2 ml-auto">
            {{ $t('campaignSetting.registrationCouponCount') }}:
            {{ coupons.length }} {{ $t('campaignSetting.people') }}
          </v-card-text>
        </v-card>

        <v-alert
          v-if="createErrorMessage"
          type="error"
          class="mx-auto mt-5"
          width="80%"
          dismissible
          @input="createErrorMessage = ''"
        >
          {{ createErrorMessage }}
        </v-alert>

        <v-card-actions class="justify-center py-8">
          <v-btn text @click="dialogConfirm = false">
            {{ $t('common.cancle') }}
          </v-btn>

          <v-btn
            class="btn_shadow"
            color="#1b2643"
            dark
            @click="setCampaign"
          >
            {{ $t('campaignSetting.edit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" width="600px">
      <v-card class="mx-auto">
        <v-card-title class="justify-center">
          {{ $t('campaignSetting.deleteDialog.campaignDelete') }}
        </v-card-title>

        <v-card-text>
          {{ campaignCodeField }}
          （{{ campaignNameField }}）{{
            $t('campaignSetting.deleteDialog.campaignDeleteMessage')
          }}
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn color="#1b2643" text @click="deleteCampaign">
            {{ $t('common.delete') }}
          </v-btn>
          <v-btn color="#1b2643" text @click="dialogDelete = false">
            {{ $t('common.cancle') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading-circle
      :isLoading="isLoading"
      :text="String($t('campaignSetting.loadingCircleMessage'))"
      :progressValue="couponProgressValue"
    />
</div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import moment from "moment-timezone";
import type { TranslateResult } from "vue-i18n";
import { agentGroupService } from "@/api/agentGroupService";
import { ResponseStatus } from "@/api/apiClient";
import { campaignCouponService } from "@/api/campaignCouponService";
import { campaignService } from "@/api/campaignService";
import LoadingCircle from "@/components/Dashboard/PageViewItems/LoadingCircleComponent.vue";
import SetSchedule from "@/components/Dashboard/PageViewItems/SetScheduleComponent.vue";
import type { AgentGroup } from "@/resources/agentGroup";
import type { ScenarioSelectItem, ScenarioWithId } from "@/resources/scenario";
import store from "@/store";
import { getCampaignById } from "@/utils/campaignUtils";
import { getLocalizedErrorKey } from "@/utils/errorUtils";
import { fetchScenarios } from "@/utils/scenarioUtils";

type CouponType = {
  id: number;
  couponCode: string | null;
  password: string | null;
};

type NewStudentType = {
  email: string | null;
  displayName: string | null;
};

type agentsType = {
  agentId: string;
  agentName: string;
};

type AgentGroupMap = { [agentGroupId in string]: AgentGroup };

const br = /\r\n|\n|\r/g;

export default defineComponent({
  name: "SetExam",

  components: {
    SetSchedule,
    LoadingCircle,
  },

  props: {
    campaignId: { type: String, default: "" },
    campaignCode: { type: String, default: "" },
    campaignName: { type: String, default: "" },
    isUnlimited: { type: Boolean, default: false },
    limits: { type: String, default: "" },
    couponNum: { type: Number, default: 0 },
    openTime: {
      type: Number,
      default: new Date(moment().tz("Asia/Tokyo").format()).getTime(),
    },
    closedTime: {
      type: Number,
      default: new Date(moment().tz("Asia/Tokyo").format()).getTime(),
    },
    startTime: {
      type: Number,
      default: new Date(moment().tz("Asia/Tokyo").format()).getTime(),
    },
    endTime: {
      type: Number,
      default: new Date(moment().tz("Asia/Tokyo").format()).getTime(),
    },
    scenarioDocId: {
      type: String,
      default: "",
    },
    isDynamicCampaign: {
      type: Boolean,
      default: false,
    },
    hasCouponError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formInput: {
        scenarioSelectItem: null as ScenarioSelectItem | null,
      },
      dialogConfirm: false,
      dialogDelete: false,
      isLoading: false,
      couponProgressValue: 0,

      fileName: "",
      fileInput: null as File | null,
      isSettingDisabled: true,
      coupons: [] as CouponType[],
      duplicatedStudents: [] as NewStudentType[],
      newRegisterStudents: [] as NewStudentType[],
      agents: [] as agentsType[],
      agentName: "",
      campaignIdField: "",
      campaignCodeField: "",
      campaignNameField: "",
      registeredCoupons: [] as string[],
      typeLimited: "",
      isUnlimitedField: false,
      limitList: [] as string[],
      limitsField: "",
      openTimeField: new Date(moment().tz("Asia/Tokyo").format()).getTime(),
      closedTimeField: new Date(moment().tz("Asia/Tokyo").format()).getTime(),
      startTimeField: new Date(moment().tz("Asia/Tokyo").format()).getTime(),
      endTimeField: new Date(moment().tz("Asia/Tokyo").format()).getTime(),
      isMatch: false,

      limit: 0,
      couponCount: 0,

      // customerId: '' || null,
      customerCode: "",

      fileErrorMessage: "",

      // collection agentGroupsから取得用
      agentGroupMap: {} as AgentGroupMap,

      createErrorMessage: "" as string,

      isDynamic: false,
      scenarios: [] as ScenarioWithId[],
    };
  },

  async created() {
    this.initialize();
  },

  async mounted() {
    this.agentGroupMap = await this.getAgentGroupMap();
    this.scenarios = await fetchScenarios();
    this.limitList = this.fetchLimitList();
  },

  watch: {
    formInput: {
      deep: true,
      handler(val) {
        console.log("formInput:", val);
      },
    },
    async campaignId(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.resetIsdynamic();
        // Reset all fields when switching to a different campaign
        this.initialize();
      }
      // Only set scenario select item if scenarios are loaded
      if (this.scenarios.length > 0) {
        this.formInput.scenarioSelectItem = this.makeScenarioSelectItem(
          this.scenarioDocId,
        );
      }
      this.campaignIdField = newValue;
      this.getRegisteredCoupons();
    },
    campaignCode(newValue) {
      this.campaignCodeField = newValue;
    },
    campaignName(newValue) {
      this.campaignNameField = newValue;
    },
    typeLimited(newValue) {
      if (
        newValue === this.$t("campaignSetting.interviewCountOption.unlimited")
      ) {
        this.isUnlimitedField = true;
      } else if (
        newValue ===
        this.$t("campaignSetting.interviewCountOption.specifyNumber")
      ) {
        this.isUnlimitedField = false;
      }
    },
    isUnlimited(newValue) {
      this.isUnlimitedField = newValue;
    },
    limits(newValue) {
      this.limitsField = newValue;
      // propsの受け渡し順的に、limitsの後にisunlimitedの変化を記述
      if (this.isUnlimitedField) {
        this.typeLimited = this.$t(
          "campaignSetting.interviewCountOption.unlimited",
        ) as string;
      } else {
        this.typeLimited = this.$t(
          "campaignSetting.interviewCountOption.specifyNumber",
        ) as string;
      }
    },
    couponNum(newValue) {
      this.couponCount = newValue;
    },
    hasCouponError: {
      handler(newValue) {
        if (newValue) {
          this.fileInput = null;
          this.coupons = [];
          this.fileErrorMessage = this.$t(
            "campaignSetting.variation.required",
          ) as string;
        }
      },
      immediate: true,
    },
    openTime(newValue) {
      this.openTimeField = newValue;
    },
    closedTime(newValue) {
      this.closedTimeField = newValue;
    },
    startTime(newValue) {
      this.startTimeField = newValue;
    },
    endTime(newValue) {
      this.endTimeField = newValue;
    },
    openTimeField(newValue) {
      if (this.isMatch) {
        this.startTimeField = newValue;
      }
    },
    closedTimeField(newValue) {
      if (this.isMatch) {
        this.endTimeField = newValue;
      }
    },
    isMatch(newValue) {
      if (newValue) {
        // マッチさせる場合の処理
        this.startTimeField = this.openTimeField;
        this.endTimeField = this.closedTimeField;
      }
    },
    scenarioDocId(val) {
      if (this.isDynamic) {
        this.formInput.scenarioSelectItem = null;
      } else {
        this.formInput.scenarioSelectItem = this.makeScenarioSelectItem(val);
      }
    },
    isDynamic(newValue) {
      if (newValue) {
        this.formInput.scenarioSelectItem = null;
      }
    },
    isDynamicCampaign(newVal) {
      this.isDynamic = newVal;
    },
    scenarios() {
      // When scenarios are loaded, update the scenario select item if needed
      if (!this.isDynamic && this.scenarioDocId) {
        this.formInput.scenarioSelectItem = this.makeScenarioSelectItem(
          this.scenarioDocId,
        );
      }
    },
  },

  computed: {
    // 未入力がある場合はボタンを押せないようにする処理
    inputted() {
      let isDisabled = false;
      // キャンペーンコードが未入力だった場合
      if (this.campaignCodeField.length === 0) {
        isDisabled = true;
      }
      // キャンペーンコードが未入力だった場合
      if (this.campaignNameField.length === 0) {
        isDisabled = true;
      }
      // 受験回数が未入力だった場合
      if (this.typeLimited.length === 0) {
        isDisabled = true;
      }
      // 受験回数が、「制限回数を設定する」と「無制限」以外だった場合
      if (!this.limitList.includes(this.typeLimited)) {
        isDisabled = true;
      }
      // 受験回数が「制限回数を設定する」かつ回数が未入力だった場合
      if (!this.isUnlimitedField && this.limitsField.length === 0) {
        isDisabled = true;
      }
      // 受験回数が「制限回数を設定する」かつ回数が英数字じゃなかった場合
      if (!this.isUnlimitedField && !/^[0-9]/.test(this.limitsField)) {
        isDisabled = true;
      }
      // クローズの時刻より公開時刻の方が遅かった場合
      if (this.closedTimeField <= this.openTimeField) {
        isDisabled = true;
      }
      // 終了時刻より開始時刻の方が遅かった場合
      if (this.endTimeField <= this.startTimeField) {
        isDisabled = true;
      }

      if (this.endTimeField > this.closedTimeField) {
        isDisabled = true;
      }
      if (this.startTimeField < this.openTimeField) {
        isDisabled = true;
      }

      // シナリオプルダウンの値がdefaultかstringの場合
      if (
        (!this.isDynamic && this.formInput.scenarioSelectItem === null) ||
        typeof this.formInput.scenarioSelectItem === "string"
      ) {
        isDisabled = true;
      }

      return isDisabled;
    },
    rules() {
      return {
        required: (value: string) =>
          !!value || this.$t("campaignSetting.variation.required"),
        halfSize: (value: string) =>
          /^[a-zA-Z0-9_-]*$/.test(value) ||
          this.$t(
            "campaignSetting.variation.inputAlphanumericHyphenUnderscore",
          ),
        number: (value: string) =>
          /^[0-9]*$/.test(value) ||
          this.$t("campaignSetting.variation.inputHalfWidthNumber"),
        inLimitList: (value: string) =>
          this.limitList.includes(value) ||
          this.$t("campaignSetting.variation.chooseFromOptions"),
        validSelection: (value: ScenarioSelectItem) => {
          if (!value)
            return this.$t("campaignSetting.variation.chooseFromOptions");
          const isItemInList = this.scenarioSelectItems.some(
            (item) => item.id === value.id,
          );
          return (
            isItemInList ||
            this.$t("campaignSetting.variation.chooseFromOptions")
          );
        },
      };
    },
    scenarioSelectItems(): ScenarioSelectItem[] {
      const returnedScenarioSelectItems = this.scenarios
        .map((scenario) => this.makeScenarioSelectItem(scenario.id))
        .filter((item) => item !== null) as ScenarioSelectItem[];
      return returnedScenarioSelectItems;
    },
  },

  methods: {
    // propsの引き渡し
    initialize() {
      this.campaignIdField = this.campaignId;
      this.campaignCodeField = this.campaignCode;
      this.campaignNameField = this.campaignName;
      this.limitsField = this.limits;
      this.openTimeField = this.openTime;
      this.closedTimeField = this.closedTime;
      this.startTimeField = this.startTime;
      this.endTimeField = this.endTime;
      this.isDynamic = this.isDynamicCampaign;
      this.typeLimited = this.isUnlimited
        ? (this.$t("campaignSetting.interviewCountOption.unlimited") as string)
        : (this.$t(
            "campaignSetting.interviewCountOption.specifyNumber",
          ) as string);
      this.fileName = "";
      this.fileInput = null;
      this.fileErrorMessage = this.hasCouponError
        ? (this.$t("campaignSetting.variation.required") as string)
        : "";

      // 「クーポンリストの追加」をしなくても「修正ボタン」を押せるようisSettingDisableをfalseにする
      this.isSettingDisabled = false;
    },

    turnBack(emitingText: TranslateResult | string) {
      this.coupons = [];
      this.fileName = "";
      this.$emit("closeComponent", emitingText);
    },

    async deleteCampaign() {
      this.dialogDelete = false;

      await campaignService.deleteByIdOrCode(this.campaignIdField);

      this.$emit("deleteItem");
    },

    // 修正時に登録済みのcoupon名を取得
    async getRegisteredCoupons() {
      this.registeredCoupons = [];
      const coupons = await campaignCouponService.list(this.campaignIdField);
      this.registeredCoupons = coupons.map((coupon) => coupon.id);
    },

    // 受験者リストの読み込み用関数
    getFileContent(e: File) {
      if (e === null || e === undefined) {
        this.coupons = [];
        this.fileErrorMessage = "";
        this.isSettingDisabled = false;
      } else {
        this.fileName = e.name;
        const reader = new FileReader();
        const file = e;
        const coupons = [] as CouponType[];
        const couponIds = [] as string[];
        let isValidation = true;
        let isNull = false;
        let isColValidation = true;
        let isUploadDuplicated = false;

        const isDuplicated = (l1: string[], l2: string[]) => {
          const common = l1.filter((x) => l2.includes(x));
          return common.length !== 0;
        };

        const loadFunc = () => {
          var lines = [] as string[];
          if (reader.result !== null) {
            lines = (reader.result as string).split(br);
          }
          let i = 0;

          // 最後の列が空白の場合はそれを消す
          if (
            lines[lines.length - 1] === "" ||
            lines[lines.length - 1] === undefined
          ) {
            lines = lines.slice(0, -1); // 最後の要素以外を取り出す
          }

          lines.forEach((element: string) => {
            const couponData = element.split(",");

            // 列が2列以外の場合はvalidationをfalseにする
            if (couponData.length !== 2) {
              isColValidation = false;
            } else {
              const couponCode = couponData[0];
              const password = couponData[1];

              if (
                (couponCode === "" && password === undefined) ||
                (couponCode === undefined && password === "") ||
                (couponCode === undefined && password === undefined)
              ) {
                // pass
              } else if (
                (couponCode === "" && password === "") ||
                (couponCode !== "" && password === "") ||
                (couponCode === "" && password !== "")
              ) {
                isNull = true;
              } else {
                // 受験者データのアップロード方法が「一時IDとパスワード」の場合
                // クーポンコードのバリデーションチェック
                if (!/^[a-zA-Z0-9_-]*$/.test(couponCode)) {
                  isValidation = false;
                }
                // パスワードのバリデーションチェック
                if (!/^[a-zA-Z0-9_-]*$/.test(password)) {
                  isValidation = false;
                }

                // アップロードしたクーポン同士で重複がないかチェック
                if (couponIds.includes(couponCode)) {
                  isUploadDuplicated = true;
                }

                const coupon = {
                  id: i,
                  couponCode: couponCode,
                  password: password,
                };
                coupons.push(coupon);
                couponIds.push(couponCode);
                i++;
              }
            }
          });

          // エラーの表示なようは検討の余地あり
          if (isDuplicated(couponIds, this.registeredCoupons)) {
            // 修正時に、新規に登録するクーポンとすでに登録されたクーポンに重複がないか確認
            this.fileErrorMessage = this.$t(
              "campaignSetting.variation.containsRegisteredCoupon",
            ) as string;
            this.isSettingDisabled = true;
          } else if (isUploadDuplicated) {
            // アップロードしたファイルで、クーポンコード同士に重複がないかチェック
            this.fileErrorMessage = this.$t(
              "campaignSetting.variation.containsDuplicateCoupon",
            ) as string;
            this.isSettingDisabled = true;
          } else if (!isColValidation) {
            // 列が2列ではなかった場合
            this.fileErrorMessage = this.$t(
              "campaignSetting.variation.invalidFileFormat",
            ) as string;
            this.isSettingDisabled = true;
          } else if (isNull) {
            // クーポンコード及びパスワードに空白があった場合
            this.fileErrorMessage = this.$t(
              "campaignSetting.variation.blankCouponOrPasswordError",
            ) as string;
            this.isSettingDisabled = true;
          } else if (!isValidation) {
            // クーポンコード及びパスワードに半角英数字・ハイフン・アンダーバー以外も含まれていた場合
            this.fileErrorMessage = this.$t(
              "campaignSetting.variation.validCouponPasswordFormat",
            ) as string;
            this.isSettingDisabled = true;
          } else {
            this.coupons = coupons;
            this.isSettingDisabled = false;
            this.fileErrorMessage = "";
          }
        };

        reader.onload = loadFunc;
        reader.readAsBinaryString(file);
      }
    },

    getFileSample() {
      var sampleData = "";
      for (let i = 0; i < 5; i++) {
        const sampleLine = "ticketId" + i + "," + "password" + i + "\n";
        sampleData += sampleLine;
      }
      const blob = new Blob([sampleData], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "sample.csv";
      link.click();
    },

    // 確認画面の「登録する」ボタンで呼び出される
    // DBへデータを投げる処理
    async setCampaign() {
      this.isLoading = true;
      this.createErrorMessage = "";

      try {
        const customerId = store.state.customerId;
        if (!customerId) {
          return;
        }

        // ここからバッチ処理(#111)
        const prevCouponCount = this.couponCount;
        const cleanedCoupons = this.coupons
          .map((coupon) => ({
            couponCode: coupon.couponCode?.trim() ?? "",
            password: coupon.password?.trim() ?? "",
            isConfirmed: false,
            learnerId: null,
          }))
          .filter((coupon) => coupon.couponCode && coupon.password);

        this.couponProgressValue = 0;
        const editCreatedCoupons = await campaignCouponService.createMany(
          this.campaignIdField,
          cleanedCoupons,
        );
        if (
          cleanedCoupons.length > 0 &&
          editCreatedCoupons.length < cleanedCoupons.length
        ) {
          this.dialogConfirm = false;
          this.isLoading = false;
          this.$root.$emit("showSnackbar", {
            message: this.$t(
              "campaignSetting.error.editCouponsFailed",
            ) as string,
            actionButtonText: this.$t("common.retry") as string,
            editCampaignCode: this.campaignCodeField,
          });
          this.$emit("closeComponent", "");
          return;
        }
        const couponCountUpdateResponse =
          await campaignService.updateByIdOrCode(this.campaignIdField, {
            couponCount: prevCouponCount + cleanedCoupons.length,
          });
        if (
          couponCountUpdateResponse.status !== ResponseStatus.Ok ||
          !couponCountUpdateResponse.result
        ) {
          const errorKey = getLocalizedErrorKey(
            couponCountUpdateResponse.errorMessage,
            "campaignSetting.error.editCampaignFailed",
          );
          this.createErrorMessage = this.$t(errorKey) as string;
          return;
        }
        this.couponProgressValue = 100;

        const campaignUpdateResponse = await campaignService.updateByIdOrCode(
          this.campaignIdField,
          {
            campaignCode: this.campaignCodeField,
            name: this.campaignNameField,
            openAt: this.UnixTimeToUTC(this.openTimeField),
            closedAt: this.UnixTimeToUTC(this.closedTimeField),
            startAt: this.UnixTimeToUTC(this.startTimeField),
            endAt: this.UnixTimeToUTC(this.endTimeField),
            scenarioDocId: this.isDynamic
              ? ""
              : (this.formInput.scenarioSelectItem?.id ?? ""),
            isDynamic: this.isDynamic,
            isUnlimited: this.isUnlimitedField,
            isShow: false,
            limits: this.isUnlimitedField ? 0 : Number(this.limitsField),
          },
        );
        if (
          campaignUpdateResponse.status !== ResponseStatus.Ok ||
          !campaignUpdateResponse.result
        ) {
          const errorKey = getLocalizedErrorKey(
            campaignUpdateResponse.errorMessage,
            "campaignSetting.error.editCampaignFailed",
          );
          this.createErrorMessage = this.$t(errorKey) as string;
          return;
        }

        this.dialogConfirm = false;

        this.$root.$emit("showSnackbar", {
          message: this.$t("campaignSetting.success.campaignUpdated") as string,
          color: "blue",
          actionButtonText: this.$t(
            "campaignSetting.success.viewCampaign",
          ) as string,
          scrollToSelector: `[data-campaign-code="${this.campaignCodeField}"]`,
        });
        this.$emit("closeComponent", "");
      } catch (error) {
        console.error("error:", error);
        this.createErrorMessage = this.$t(
          "campaignSetting.error.editCampaignFailed",
        ) as string;
      } finally {
        this.couponProgressValue = 0;
        this.isLoading = false;
      }
    },

    setCustomerId() {
      this.customerId = store.state.customerId;
    },

    UnixTimeToString(UnixTime: number) {
      return moment(UnixTime).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
    },

    // 時差問題が生じていた原因となる箇所
    UnixTimeToUTC(UnixTime: number) {
      return moment(UnixTime).utc().format("YYYY-MM-DDTHH:mm:ss") + ".000Z";
    },

    async getAgentGroupMap(): Promise<AgentGroupMap> {
      const agentGroups = await agentGroupService.list();
      return Object.fromEntries(
        agentGroups.map((agentGroup) => [agentGroup.id, agentGroup]),
      );
    },
    makeScenarioSelectItem(scenarioId: string): ScenarioSelectItem | null {
      const scenario = this.scenarios.find(
        (scenario) =>
          scenario.scenarioIdLegacy === scenarioId ||
          scenario.id === scenarioId,
      );
      if (scenario === undefined) return null;
      const agentGroup = this.agentGroupMap[scenario.agentGroupId];
      if (agentGroup === undefined) return null;
      return {
        label: `${scenario.name} - ${agentGroup?.name ?? ""}`,
        ...scenario,
      };
    },
    fetchLimitList() {
      return [
        this.$t("campaignSetting.interviewCountOption.specifyNumber") as string,
        this.$t("campaignSetting.interviewCountOption.unlimited") as string,
      ];
    },
    async resetIsdynamic() {
      try {
        if (!this.campaignId) {
          this.isDynamic = false;
          return;
        }
        const campaign = await getCampaignById(this.campaignId);
        if (campaign) {
          this.isDynamic = !!campaign.isDynamic;
        } else {
          this.isDynamic = false;
        }
      } catch (error) {
        console.error(error);
        this.isDynamic = false;
      }
    },
  },
});
</script>
